import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { useIsPuzzleWalletWebView } from './useIsPuzzleWalletWebView';

type ArcadeStorePromptState = {
  hasViewedPrompt: boolean;
  onPromptViewed: () => any;
};

const arcadeStorePromptState = create<ArcadeStorePromptState>()(
  persist(
    (set) => ({
      hasViewedPrompt: false,
      onPromptViewed: () => {
        set({ hasViewedPrompt: true });
      },
    }),
    {
      name: 'puzzle-arcade-store-prompt',
    }
  )
);

export const useArcadeStorePrompt = () => {
  const [hasViewedPrompt, onPromptViewed] = arcadeStorePromptState((state) => [
    state.hasViewedPrompt,
    state.onPromptViewed,
  ]);

  return {
    hasViewedPrompt,
    onPromptViewed,
  };
};

export const useArcadeStoreLink = () => {
  const isPuzzleWalletWebview = useIsPuzzleWalletWebView();

  if (isPuzzleWalletWebview) {
    return `https://app.puzzle.online/store`;
  } else {
    return 'https://store.puzzle.online';
  }
};
